import { render, staticRenderFns } from "./forMe.vue?vue&type=template&id=35596476&scoped=true"
import script from "./forMe.vue?vue&type=script&lang=js"
export * from "./forMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35596476",
  null
  
)

export default component.exports